import { render } from "./ListEmployPage.vue?vue&type=template&id=bcf1061c&scoped=true&ts=true"
import script from "./ListEmployPage.vue?vue&type=script&lang=ts"
export * from "./ListEmployPage.vue?vue&type=script&lang=ts"

import "./ListEmployPage.vue?vue&type=style&index=0&id=bcf1061c&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DanhGia_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf1061c"]])

export default __exports__